var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsIn = function SvgIconArrowsIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.793 3.793a1 1 0 0 1 1.414 0L8.75 7.336V6a1 1 0 0 1 2 0v3.75a1 1 0 0 1-1 1H6a1 1 0 1 1 0-2h1.336L3.793 5.207a1 1 0 0 1 0-1.414M20.207 3.793a1 1 0 0 1 0 1.414L16.664 8.75H18a1 1 0 1 1 0 2h-3.75a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v1.336l3.543-3.543a1 1 0 0 1 1.414 0M5 14.25a1 1 0 0 1 1-1h3.75a1 1 0 0 1 1 1V18a1 1 0 1 1-2 0v-1.336l-3.543 3.543a1 1 0 0 1-1.414-1.414l3.543-3.543H6a1 1 0 0 1-1-1M13.25 14.25a1 1 0 0 1 1-1H18a1 1 0 1 1 0 2h-1.336l3.543 3.543a1 1 0 0 1-1.414 1.414l-3.543-3.543V18a1 1 0 1 1-2 0z"
  }))));
};
export default SvgIconArrowsIn;